<template>
  <v-form>
    <v-tabs
      v-model="tab"
      background-color="white"
      color="primary"
      style="margin-bottom:20px;"
    >
      <v-tab href="#tab-1">Inställningar</v-tab>
      <v-tab href="#tab-2">Betalning</v-tab>
      <v-tab href="#tab-3">Administratörer</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item :key="'1'" :value="'tab-1'">
        <div style="display: flex;">
          <div class="v-input__prepend-outer">
            <v-icon>mdi-clock-outline</v-icon>
          </div>
          <v-datetime-picker
            label="Datum och tid"
            v-model="form.date"
            prepend-icon="mdi-clock"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            required
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>mdi-clock</v-icon>
            </template>
          </v-datetime-picker>
        </div>
        <v-text-field
          v-model="form.name"
          label="Namn"
          prepend-icon="mdi-form-textbox"
        ></v-text-field>
        <v-text-field
          v-model="form.videoLink"
          label="Länk till videomöte"
          prepend-icon="mdi-video-outline"
          hint="Länken visas för mötesdeltagarna"
        ></v-text-field>
        <v-switch
          v-model="form.askToSpeak"
          :label="`Tillåt användare att begära ordet`"
        ></v-switch>
      </v-tab-item>
      <v-tab-item :key="'2'" :value="'tab-2'">
        <div
          style="
            margin-top: 10px;
            margin-bottom: 30px;
            border: 1px solid #ccc;
            padding: 11px;
            border-radius: 4px;
            "
        >
          <p>
            Alla möten med upp till <b>fem deltagare är gratis</b>. För att
            hålla större möten krävs att du anger en betalmetod.
          </p>
          <p>
            <strong
              >Ingen transaktion kommer ske om mötet inte startas.
            </strong>
            <a href="https://www.percap.se/priser" target="_blank">
              Tryck här för att se prislista
            </a>
          </p>
          <template
            v-if="!this.organization || organization.invoicingStatus !== 1"
          >
            <p>
              Du kan ansöka om fakturabetalning i inställningarna för din
              organisation
            </p>
          </template>
        </div>
        <v-select
          v-if="hasContracts"
          v-model="form.contract"
          :items="contracts"
          label="Betalmetod - Avtal"
          prepend-icon="mdi-file-document-edit-outline"
        ></v-select>
        <template
          v-if="!this.organization || organization.invoicingStatus !== 1"
        >
          <v-select
            v-model="form.stripePaymentMethod"
            :items="stripePaymentMethods"
            label="Betalningsmetod - Kortbetalning"
            prepend-icon="mdi-credit-card-check-outline"
          ></v-select>
          <v-btn text color="primary" type="button" @click="addStripePayment"
            >Lägg till betalningsmetod</v-btn
          >
          <h3 style="margin-top:20px;">Rabattkod</h3>
          <v-row>
            <v-col cols="8">
              <v-text-field
                v-model="form.promotionCode"
                label="Rabattkod"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <p
                v-if="form.promotionId"
                style=" margin-top: 10px;
                        border: 1px solid green;
                        padding: 11px;
                        border-radius: 4px;
                        color: green;
                      "
              >
                <v-icon color="success">mdi-check</v-icon> Rabattkod inlagd.
              </p>
            </v-col>
          </v-row>
        </template>
      </v-tab-item>
      <v-tab-item :key="'3'" :value="'tab-3'">
        <h3>Administratörer</h3>
        <v-list>
          <v-list-item-group color="primary">
            <v-list-item v-for="(admin, i) in form.admin" :key="i">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon color="grey lighten-1">mdi-account</v-icon>
                  {{ admin }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click="removeAdmin(admin)">
                  <v-icon color="warning">mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-row style="align-items:baseline">
          <v-col cols="12">
            <h3>Lägg till administratör</h3>
          </v-col>
          <v-col cols="9" style="padding-top:0;">
            <v-text-field
              v-model="newAdmin"
              label="Personnummer"
              :rules="ssnRules"
            ></v-text-field>
          </v-col>
          <v-col cols="3" style="padding-top:0;">
            <v-btn small @click="addAdmin">Lägg till</v-btn>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-form>
</template>

<script>
import axios from "axios";
import config from "../../../config.js";
import { isSSN } from "@/assets/lib/isSSN.js";
import { httpBaseUrl } from "../../plugins/firebase.js";

const form = {
  name: "",
  date: null,
  videoLink: "",
  contract: null,
  stripePaymentMethod: null,
  stripeCustomerId: null,
  admin: [],
  promotionCode: null,
  promotionId: null,
  askToSpeak: false
};

export default {
  props: {
    meeting: Object,
    organization: Object
  },
  computed: {
    contracts() {
      const items = (this.user.contracts || []).map(c => {
        return { value: c.id, text: c.name };
      });
      if (this.organization && this.organization.invoicingStatus === 1) {
        items.push({
          value: this.organization.invoiceContractId,
          text: this.organization.name
        });
      }
      return [{ value: null, text: "(inget avtal)" }, ...items];
    },
    stripePaymentMethods() {
      const items = (this.user.stripePaymentMethods || []).map(c => {
        return { value: c.id, text: c.name };
      });

      return [{ value: null, text: "(ingen betalningsmetod)" }, ...items];
    },
    hasContracts() {
      return (
        (this.user.contracts && this.user.contracts.length > 0) ||
        (this.organization && this.organization.invoicingStatus === 1)
      );
    },
    hasStripePaymentMethods() {
      return (
        this.user.stripeCustomerId &&
        this.user.stripePaymentMethods &&
        this.user.stripePaymentMethods.length > 0
      );
    },
    user() {
      return this.$store.getters["auth/user"];
    },
    auth() {
      return this.$store.getters["auth/auth"];
    },
    isSSN() {
      return isSSN(this.newAdmin);
    }
  },
  data() {
    return {
      form: { ...form },
      dateProps: {
        firstDayOfWeek: 1,
        locale: "sv-SE",
        min: new Date().toISOString().slice(0, 10)
      },
      timeProps: {
        format: "24hr"
      },
      tab: "",
      newAdmin: "",
      ssnRules: [
        v => isSSN(v) || `Måste vara ett personnummer i formatet ÅÅÅÅMMDDNNNN`
      ]
    };
  },
  methods: {
    resetForm(meeting) {
      if (!meeting) {
        if (this.organization && this.organization.invoicingStatus === 1) {
          this.form.contract = this.organization.invoiceContractId;
        }
        return;
      }

      const data = {
        name: meeting.name,
        date: meeting.date.toDate(),
        videoLink: meeting.videoLink,
        contract: meeting.contractId,
        stripePaymentMethod: meeting.stripePaymentMethod,
        stripeCustomerId:
          meeting.stripeCustomerId || this.user.stripeCustomerId,
        admin: meeting.admin,
        promotionCode: meeting.promotionCode,
        promotionId: meeting.promotionId,
        askToSpeak: meeting.askToSpeak
      };

      this.form = { ...this.form, ...data };
    },
    async addStripePayment() {
      var stripe = window.Stripe(config.stripePublicKey);
      const stripeSession = await axios.post(
        `${httpBaseUrl}/onCreateCheckoutSession`,
        { userId: this.auth.uid, meetingId: this.meeting.id }
      );
      if (stripeSession.status === 200) {
        stripe
          .redirectToCheckout({
            sessionId: stripeSession.data.sessionId
          })
          .then(() => {});
      }
    },
    close() {
      this.form = { ...form };
      this.$emit("close");
      this.resetForm(this.meeting);
    },
    addAdmin() {
      if (!this.newAdmin || !this.isSSN) return;
      this.form.admin.push(this.newAdmin);
      this.newAdmin = "";
    },
    removeAdmin(pnr) {
      this.form.admin = this.form.admin.filter(item => item !== pnr);
    }
  },
  mounted() {
    this.resetForm(this.meeting);
  }
};
</script>

<style></style>
